export interface PosConfig {
  apiConfig: {
    /** Empty means the in-memory demo API. */
    baseUrl?: string
    bearerToken?: string | null
    /** The host the tenant is resolved from (`X-Client-Host`). */
    clientHost?: string | null
    /** `X-System-Uid`, fetched once per device. */
    systemUid?: string | null
    /** `X-Device-Id`: this browser's id, sent once it is linked (POS.md O2). */
    deviceUid?: string | null
    /** `X-Terminal-Id`: the terminal this device is set up as, for the back office's "last synced". */
    terminalId?: string | null
  }
}

class ConfigService {
  private config: PosConfig = { apiConfig: {} }

  setConfig(config: PosConfig) {
    this.config = config
  }

  setApiConfig(apiConfig: Partial<PosConfig['apiConfig']>) {
    this.config = { ...this.config, apiConfig: { ...this.config.apiConfig, ...apiConfig } }
  }

  getConfig() {
    return this.config
  }

  isDemo() {
    return !this.config.apiConfig.baseUrl
  }
}

export const configService = new ConfigService()
